import React from 'react';
import { withRouter } from 'react-router';
import Swiper from 'react-id-swiper';
import $ from 'jquery';
import LocalizedStrings from 'react-localization';
// import RatingStars from './RatingStars';
import risk1Icon from '../img/risks/risk1.svg';
import risk2Icon from '../img/risks/risk2.svg';
import risk3Icon from '../img/risks/risk3.svg';
import risk4Icon from '../img/risks/risk4.svg';
import risk5Icon from '../img/risks/risk5.svg';
import risk6Icon from '../img/risks/risk6.svg';
import risk7Icon from '../img/risks/risk7.svg';

let types = [];
function InsuranceItem(props) {
  $(() => {
    $('.kasco_offer-tariff .btn').click(function () {
      $(this).toggleClass('btn-hide');
      $(this).parents('ul').toggleClass('i-show');
    });
  });

  types = props.compare.map((el) => el.tarif);

  const toggleCompare = (type) => {
    const tarif = [props.item.light, props.item.popular, props.item.premium].filter((item) => item.name === type)[0];
    const filterType = props.compare.filter((el) => el.tarif.name === tarif.name && el.insuranceCompanyName === props.item.insuranceCompanyName);

    if (filterType.length === 0) {
      props.addCompareToList({
        ...props.item,
        tarif,
      });
      types.push(tarif);
      $('#compare-message').show();
      setTimeout(() => {
        $('#compare-message').hide();
      }, 5000);
    } else {
      props.removeCompareFromList({
        id: props.item.insuranceCompanyCode,
        tarif,
      });
      types = types.filter((el) => el.name !== tarif.name);
    }
  };

  const handleRedirect = (e) => {
    // window.gtag('event', 'click', { 'event_category': 'button3' });
    const tarif = e.target.id.split(',')[1];
    props.history.push({
      pathname: props.locale === 'ua' ? '/uk/kasko/apply' : '/kasko/apply',
      search: `${props.location.search}&type=${tarif}`,
    });
  };

  const isTarifInCompareList = (tarifName) => {
    const companies = props.compare.filter(item => item.insuranceCompanyCode === props.item.insuranceCompanyCode);

    if (companies.length > 0) {
      return companies.filter(item => item.tarif.name === tarifName).length !== 0;
    }

    return false;
  };

  const strings = new LocalizedStrings({
    ru: {
      get: 'Получи',
      cashback: 'кешбэка',
      sale: 'акция',
      promo: 'по Промокоду',
      polis: 'Полис',
      mark: 'оценок',
      reviews: 'Отзывы о компании',
      show: 'показать все',
      hide: 'свернуть',
      add: 'Выбрать',
      compare: 'Добавить в сравнения',
      conditionsTitle: "Условия",
      risksTitle: "Покрываемые риски",
      risk1: "ДТП",
      risk2: "Угон",
      risk3: "Стихийные бедствия",
      risk4: "Случайные повреждения",
      risk5: "Полная гибель авто",
      risk6: "Взрыв, пожар",
      risk7: "Противоправные действия третьих лиц",
      franchiseDamage: 'повреждения',
      franchiseStealing: 'угон'
    },
    ua: {
      get: 'Отримай ',
      cashback: 'кешбеку',
      sale: 'акція',
      promo: 'за промокодом',
      polis: 'Поліс',
      mark: 'оцінок',
      reviews: 'Відгуки про компанію',
      show: 'Показати всі',
      hide: 'Сгорнути всі',
      add: 'Обрати',
      compare: 'Додати до порівняння',
      conditionsTitle: "Умови",
      risksTitle: "Ризики, що покриваються",
      risk1: "ДТП",
      risk2: "Викрадення",
      risk3: "Стихійні лиха",
      risk4: "Випадкові пошкодження",
      risk5: "Повна загибель авто",
      risk6: "Вибух, пожежа",
      risk7: "Протиправні дії третіх осіб",
      franchiseDamage: 'пошкодження',
      franchiseStealing: 'викрадення'
    },
  });

  strings.setLanguage(props.locale);

  // params for Swiper
  const params = {
    slidesPerView: 'auto',
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
    }
  }

  return (
    <div className="kasco_offer-block">
      <div className="kasco_offer-item">
        {/* {props.item.with_cashback.status === true
        && (
        <div className="action-block flex flex_j-space-between">
          <div className="flex">
            <div className="tit">{strings.sale}</div>
            <h2>{strings.get} <span className="color-blue">10% {strings.cashback}</span> {strings.promo} «ALFA»</h2>
          </div>
          <div className="date">до {props.item.with_cashback.date}</div>
        </div>
        )} */}

        <div className="row">
          <div className="company">

            {/* logo */}
            <div className="logo-company">
              <picture>
                <source type="image/webp" srcSet={props.item.insuranceCompanyLogoWebp} />
                <img src={props.item.insuranceCompanyLogoPng} alt={props.item.insuranceCompanyName} />
              </picture>
            </div>
            {/* End logo */}

          </div>
          <div className="company-info">
            <div className="txt">
              <div className="tit">{strings.polis} КАСКО</div>
              <h2>{props.item.insuranceCompanyName}</h2>
              <p>{props.item.insuranceCompanyDescription}</p>
            </div>

            {/* rating */}
            {/* <div className="rating">
              <div className="row">
                <div className="mob-w100">
                  <p>Рейтинг МТСБУ</p>
                  <div className="flex">
                    <RatingStars mark='4.5' />
                    <p>4.5<a href="#/">({props.item.marks_count} {strings.mark})</a></p>
                  </div>
                </div>
                <a href="#/" className="review-company">
                  {strings.reviews}
                  <span>({props.item.reviews})</span>
                </a>
              </div>
            </div> */}
            {/* End rating */}

          </div>
        </div>
      </div>{/* item */}
      <div className="kasco_offer-item kasco_offer-tariff">
        <div className="company-tariff row flex_a-start">
          <Swiper {...params}>
            {[props.item.light, props.item.popular, props.item.premium].map((item, id) => (
              <div className="tariff-item" key={item.name}>
                <div className="txt">
                  <h3>Пакет</h3>
                  <div className="tit"><h3>«{item.name}»</h3></div>
                </div>
                <div className="table">
                  <div className="table-row">
                    <span>Тариф</span>
                    <span>{item.tarif}%</span>
                  </div>
                  <div className="table-row">
                    <span>Франшиза <br /> ({strings.franchiseDamage})</span>
                    <span>{item.dtpFranchise}%</span>
                  </div>
                  <div className="table-row">
                    <span>Франшиза <br /> ({strings.franchiseStealing})</span>
                    <span>{item.ugonFranchise}%</span>
                  </div>
                </div>

                {/* bonuses */}
                <ul className="bonuses">
                  {item.bonuses.map((el, index) => (
                    <li className="check" key={index}>
                      <span>
                        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13 1L4.84 9L1 5.23529" stroke="#0A7E3E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M13 1L4.84 9L1 5.23529" stroke="#189851" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </span>
                      <p>{el}</p>
                    </li>
                  ))}

                  {/* <div className="btn btn-show">
                  <p>
                    <span className="txt-show">{strings.show}</span>
                    <span className="txt-hide">{strings.hide}</span>
                  </p>

                  <svg width={10} height={7} viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 1L5 5.17391L1 1" stroke="#0A7E3E" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M9 1L5 5.17391L1 1" stroke="#189851" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div> */}
                </ul>
                {/* End bonuses */}

                <div className="bottom">
                  <div className="price">
                    {
                      item.amountWithDiscount ?
                        (Math.floor(item.amountWithDiscount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")) : (Math.floor(item.amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "))
                    }
                  &nbsp;грн
                </div>
                  <div className="flex no-wrap">
                    <button
                      type="button"
                      onClick={handleRedirect}
                      id={`${props.item.insuranceCompanyCode},${item.name}`}
                      className="btn"
                    >
                      {strings.add}
                    </button>

                    <div onClick={() => toggleCompare(item.name)} className={isTarifInCompareList(item.name) ? 'tariff-compare add' : 'tariff-compare'} >
                      <div className="tooltips" id={item.type}>{strings.compare}</div>
                      <div className="ico" id={item.type}>
                        <svg id={item.type} width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path id={item.type} d="M23.9592 12.2101L23.9388 12.2208L20.4956 3.17235H22.0667C22.3484 3.17235 22.5768 2.93119 22.5768 2.63375C22.5768 2.33631 22.3484 2.09515 22.0667 2.09515H12.4667V0.5386C12.4667 0.241158 12.2383 0 11.9566 0C11.6749 0 11.4465 0.241158 11.4465 0.5386V2.08977H1.85165C1.56995 2.08977 1.34155 2.33092 1.34155 2.62837C1.34155 2.92581 1.56995 3.16697 1.85165 3.16697H3.48905L0.0408077 12.2101C0.0153029 12.2731 0.00146653 12.3408 0 12.4093C0 14.8827 1.89896 16.8878 4.24145 16.8878C6.58393 16.8878 8.48289 14.8827 8.48289 12.4093C8.48142 12.3408 8.46759 12.2731 8.44208 12.2101L4.99894 3.16158H11.4465V19.8151C9.01339 20.009 7.11073 21.5709 7.11073 23.4614C7.11073 23.7588 7.33913 24 7.62083 24H16.2925C16.5742 24 16.8026 23.7588 16.8026 23.4614C16.8026 21.5709 14.8999 20.009 12.4667 19.8151V3.16158H18.9807L15.5579 12.2101C15.5324 12.2731 15.5186 12.3408 15.5171 12.4093C15.5171 14.8827 17.4161 16.8878 19.7586 16.8878C22.101 16.8878 24 14.8827 24 12.4093C23.9985 12.3408 23.9847 12.2731 23.9592 12.2101ZM4.2389 15.8187C2.659 15.8164 1.3135 14.6055 1.061 12.9587H7.39639C7.14517 14.5975 5.81107 15.8059 4.2389 15.8187ZM7.21275 11.8815H1.27524L4.2491 4.06643L7.21275 11.8815ZM15.6905 22.9228H8.21764C8.59511 21.7648 10.1509 20.8707 11.9515 20.8707C13.7522 20.8707 15.3131 21.7648 15.6905 22.9228ZM19.7356 4.07181L22.6993 11.8815H16.7617L19.7356 4.07181ZM19.7356 15.8187V15.8241C18.1618 15.8108 16.8271 14.5996 16.5781 12.9587H22.9135C22.661 14.6055 21.3155 15.8164 19.7356 15.8187Z" fill="#788392" />
                        </svg>
                      </div>
                      <div className="ok"><svg width={10} height={8} viewBox="0 0 10 8" fill="none"><path d="M9 1.33398L3.56 6.66732L1 4.15751" stroke="white" strokeLinecap="round" strokeLinejoin="round" /></svg></div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Swiper>
        </div>
      </div>

      {/* details */}
      <div className="details">

        {/* conditions */}
        <div className="conditions">
          <h2 className="conditions-title">{strings.conditionsTitle}</h2>
          <ul className="conditions-list">
            {
              props.item.conditions.map((el, index) => {
                return (
                  <li
                    key={index}
                    className="conditions-item"
                  >
                    <span>
                      <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 1L4.84 9L1 5.23529" stroke="#0A7E3E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M13 1L4.84 9L1 5.23529" stroke="#189851" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                    {el}
                  </li>
                )
              })
            }
          </ul>
        </div>
        {/* End conditions */}

        {/* risks */}
        <div className="risks">
          <h2 className="risks-title">{strings.risksTitle}</h2>
          <ul className="risks-list">
            <li className="risks-item">
              <span>
                <img src={risk1Icon} alt="risk" />
              </span>
              {strings.risk1}
            </li>

            <li className="risks-item">
              <span>
                <img src={risk2Icon} alt="risk" />
              </span>
              {strings.risk2}
            </li>

            <li className="risks-item">
              <span>
                <img src={risk3Icon} alt="risk" />
              </span>
              {strings.risk3}
            </li>

            <li className="risks-item">
              <span>
                <img src={risk4Icon} alt="risk" />
              </span>
              {strings.risk4}
            </li>

            <li className="risks-item">
              <span>
                <img src={risk5Icon} alt="risk" />
              </span>
              {strings.risk5}
            </li>

            <li className="risks-item">
              <span>
                <img src={risk6Icon} alt="risk" />
              </span>
              {strings.risk6}
            </li>

            <li className="risks-item">
              <span>
                <img src={risk7Icon} alt="risk" />
              </span>
              {strings.risk7}
            </li>
          </ul>
        </div>
        {/* End risks */}

      </div>
      {/* End details */}
    </div>
  );
}

export default withRouter(InsuranceItem);
